import LetOnlyManagement from "pages/PropertyPage/services/LetOnly";
import FullManagement from "pages/PropertyPage/services/Full";
import BlockManagement from "pages/PropertyPage/services/Block";
import PropertyOnboarding from "pages/PropertyPage/services/Onboarding";
import PlannedMaintenance from "pages/PropertyPage/services/PlannedMaintenance";
import ReactiveRepairs from "pages/PropertyPage/services/ReactiveRepairs";
import LandlordCompliance from "pages/PropertyPage/services/Compliance";

import sharedRoutes from "routes/shared";

const [companyRoute, helpRoute] = sharedRoutes;

const propertyRoutes = [
  companyRoute,
  {
    name: "Services",
    icon: "category",
    columns: 1,
    rowsPerColumn: 2,
    collapse: [
      {
        name: "Lettings & Onboarding",
        description: "Getting Started",
        collapse: [
          {
            name: "'Let Only' Property Management",
            description:
              "We handle tenant placement and lease setup on your behalf, then hand back day-to-day control to you — ideal for landlords who want help getting started.",
            route: "/property/let-only/",
            component: <LetOnlyManagement />,
          },
          {
            name: "Property Assessment & Onboarding",
            description:
              "We assess your property's condition, advise on compliance requirements, and set up the management framework — ensuring everything is in order before we take over.",
            route: "/property/onboarding/",
            component: <PropertyOnboarding />,
          },
        ],
      },
      {
        name: "Property Management",
        description: "Ongoing Management",
        collapse: [
          {
            name: "Full Property Management",
            description:
              "We manage every aspect of your property on your behalf, including tenant relations, maintenance coordination, rent collection, and compliance.",
            route: "/property/full/",
            component: <FullManagement />,
          },
          {
            name: "Block Management",
            description:
              "We oversee the day-to-day running of multi-unit developments, covering common area upkeep, service charge administration, and financial reporting.",
            route: "/property/block/",
            component: <BlockManagement />,
          },
        ],
      },
      {
        name: "Maintenance & Compliance",
        description: "Upkeep & Regulation",
        collapse: [
          {
            name: "Planned Preventive Maintenance",
            description:
              "We schedule regular inspections and servicing to keep your property compliant and in excellent condition — reducing costly emergency callouts before they happen.",
            route: "/property/planned-maintenance/",
            component: <PlannedMaintenance />,
          },
          {
            name: "Reactive Repairs & Emergency Response",
            description:
              "We deploy vetted contractors promptly when issues arise, protecting your property and ensuring minimal disruption to tenants.",
            route: "/property/reactive-repairs/",
            component: <ReactiveRepairs />,
          },
          {
            name: "Landlord Compliance & Certification",
            description:
              "We ensure your property meets all regulatory requirements, including gas safety, fire safety, and BER certification — keeping you compliant and your tenants safe.",
            route: "/property/compliance/",
            component: <LandlordCompliance />,
          },
        ],
      },
    ],
  },
  helpRoute,
];

export default propertyRoutes;
